import { createSlice } from "@reduxjs/toolkit";
import { getContactAPI } from "../../api/contact";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const getContactSlice = createSlice({
  name: "getContact",
  initialState: data,
  reducers: {
   getContactSlice(state) {
      state.isLoading = true;
    },
   getContactSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    getContactSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
   getContactSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const getContactHandler = (search:any,page:any,limit:any,sort_by:any,sort_direction:any) => async (dispatch: any) => {
  try {
    dispatch(getContactAction.getContactSlice());
    const response: any = await getContactAPI(search,page,limit,sort_by,sort_direction);
    
    dispatch(getContactAction.getContactSliceSuccess(response));
  } catch (e: any) {
    dispatch(getContactAction.getContactSliceFailure(e?.response?.data));
  }
};
export default getContactSlice.reducer;
export const getContactAction = getContactSlice.actions;
